module.exports = __webpack_public_path__ + "static/mucoffhomefnl-bc846eaff0b27e07b07255e7122b4cb5.jpg";